import type { ComposedForm } from 'lib-node-question-builder';

import useIsWriteAccessDisabled from '~/common/hooks/useIsWriteAccessDisabled';
import { DeleteFieldArrayRowButton } from '~/pages/Loan1003DataGrids/common/components/FormFieldArrayButtons';

import type { AddressInfoData, BorrowerAddressData } from '../../../types';
import {
  AddressCard,
  AddressCardActions,
  AddressCardContent,
  AddressCardTitle,
} from './AddressCard';
import { FieldArrayContainer } from './FieldArrayContainer';
import { createCommonAddressTemplate } from './commonAddressTemplate';

type AssociatedAddressesProps = {
  form: ComposedForm<AddressInfoData['formData']>;
  onAddressDeleted?: (addressId: number | null) => void;
};

export function AssociatedAddresses({
  form,
  onAddressDeleted,
}: Readonly<AssociatedAddressesProps>) {
  const isWriteAccessDisabled = useIsWriteAccessDisabled();

  return (
    <form.Field
      name="residenceHistoryDetails.borrowerAssociatedAddresses"
      mode="array"
    >
      {(field) => {
        return (
          <FieldArrayContainer>
            {(field.state.value as BorrowerAddressData[])?.map((_, index) => (
              <AddressCard key={_.addressIdentifier.addressId}>
                <AddressCardContent width="60%">
                  <AddressCardTitle>Address</AddressCardTitle>
                  <form.Grid
                    name="addressGrid"
                    columns={4}
                    fields={createCommonAddressTemplate(
                      `residenceHistoryDetails.borrowerAssociatedAddresses[${index}]`,
                    )}
                  />
                </AddressCardContent>
                <AddressCardActions>
                  <DeleteFieldArrayRowButton
                    readOnlyMode={isWriteAccessDisabled}
                    onClick={() => {
                      onAddressDeleted?.(
                        typeof _.addressIdentifier?.addressId === 'number'
                          ? _.addressIdentifier.addressId
                          : null,
                      );
                      field.removeValue(index);
                    }}
                  />
                </AddressCardActions>
              </AddressCard>
            ))}
          </FieldArrayContainer>
        );
      }}
    </form.Field>
  );
}
